import React from 'react';

// Catches render/runtime errors anywhere in the tree and shows a friendly,
// bilingual fallback instead of a blank white screen. Also logs the error.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Surface the real error for diagnosis (was previously a white screen).
    // eslint-disable-next-line no-console
    console.error('App crashed (ErrorBoundary):', error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const msg = this.state.error?.message || String(this.state.error || 'Unknown error');
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: '#f7f4ee', padding: '24px', fontFamily: "'Work Sans', Arial, sans-serif",
      }}>
        <div style={{
          maxWidth: '520px', width: '100%', background: '#ffffff', borderRadius: '16px',
          border: '1px solid #e2e8f0', boxShadow: '0 10px 40px rgba(15,23,42,0.10)', padding: '28px',
        }}>
          <div style={{
            width: '48px', height: '48px', borderRadius: '12px', background: '#2563eb',
            color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '24px', marginBottom: '16px',
          }}>!</div>
          <h1 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: '20px', margin: '0 0 6px', color: '#0f172a' }}>
            Es ist ein Fehler aufgetreten
          </h1>
          <p style={{ margin: '0 0 4px', color: '#475569', fontSize: '14px' }}>
            Etwas ist schiefgelaufen. Bitte lade die Seite neu.
          </p>
          <p style={{ margin: '0 0 16px', color: '#94a3b8', fontSize: '13px' }}>
            Something went wrong. Please reload the page.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              background: '#2563eb', color: '#fff', border: 'none', borderRadius: '10px',
              padding: '10px 18px', fontSize: '14px', fontWeight: 600, cursor: 'pointer',
            }}
          >
            Neu laden / Reload
          </button>
          <details style={{ marginTop: '18px' }}>
            <summary style={{ cursor: 'pointer', color: '#64748b', fontSize: '12px' }}>Details</summary>
            <pre style={{
              whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#b91c1c',
              fontSize: '12px', marginTop: '8px', fontFamily: 'ui-monospace, monospace',
            }}>{msg}</pre>
          </details>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
